module.exports = __webpack_public_path__ + "d2765b37d69aae3fc91781a278134acf.jpg";